// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__mGMq+"};